import React from 'react';
import { useSelector } from 'react-redux';
import { Route } from 'react-router-dom';
import { Skeleton } from 'antd';
import config from '@/config';

const PrivateRoute = ({ children, ...rest }) => {
  const isLogin = useSelector((state) => state.authenticate.isLogin);
  const isLoading = useSelector((state) => state.authenticate.isLoading);

  if (!isLogin && !isLoading) {
    window.location.href = `${config.contextPath}/login`;
    return null;
  }
  return isLoading ? <Skeleton loading /> : <Route {...rest} />;
};

export default PrivateRoute;
